module.exports = __webpack_public_path__ + "flame.svg";